var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 188,
    viewBox: "0 0 351 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27_2300)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9985 102.877C112.354 97.7508 139.672 88.6311 157.065 96.8633C174.517 105.123 150.671 119.5 152.003 131.75C153.271 143.413 175.945 154.404 164.411 164.43C150.686 176.36 121.264 184.272 95.2333 181.094C70.3015 178.051 60.5409 163.132 51.5866 150.658C44.8027 141.208 45.0949 131.173 52.7414 121.903C60.0587 113.031 74.1411 106.923 90.9985 102.877Z",
    fill: "#2E41EC",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27_2300",
    x: -202.541,
    y: -155.722,
    width: 619.493,
    height: 586.802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 124.64,
    result: "effect1_foregroundBlur_27_2300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.9cee0eba511f03f9d6d20c7a09d39023.svg";
export { ForwardRef as ReactComponent };